import { Deserializable } from '../protocols/deserializable';
import { MonthlyPensionBenefitPhaseTypeEnum } from './enum/monthly-pension-benefit-phase-type.enum';

export class MonthlyPensionBenefitPhase implements Deserializable {
  public phaseType!: MonthlyPensionBenefitPhaseTypeEnum;
  public monthlyAmount!: number | null;
  public lumpSum!: number | null;
  public untilDate!: string | null;

  public onDeserialize(): void {}
}
